import React, { useState, useEffect } from 'react';
import SmartSolutionsGroupLogo from '../media/images/smart-solutions-group.png';

function MainScreen(props) {
    const [topOffset, setTopOffset] = useState('60vh'); // Default for desktop (60% of viewport height)
    const [scrollOpacity, setScrollOpacity] = useState(1); // Default opacity for the scroll indicator
    const [pointerEvents, setPointerEvents] = useState('auto'); // Default pointer events

    useEffect(() => {
        // Change vh to window's inner height on mobile devices because on there vh doesn't include url bar
        if (window.screen.width < 768) // 768 is the top bootstrap breakpoint value for small devices
            document.documentElement.style.setProperty('--banner-height', `${window.innerHeight}px`);

        // Update topOffset based on screen width
        const updateTopOffset = () => {
            const screenWidth = window.innerWidth;

            // Define the screen width range for interpolation
            const minWidth = 320; // Minimum screen width (e.g., small phones)
            const maxWidth = 1800; // Maximum screen width for interpolation

            // Define the corresponding percentage range as proportions of viewport height
            const minTop = 10;
            const maxTop = 35;

            // Clamp the screen width within the range
            const clampedWidth = Math.min(Math.max(screenWidth, minWidth), maxWidth);

            // Lerp between minTop and maxTop
            const interpolatedTop =
                minTop + ((clampedWidth - minWidth) / (maxWidth - minWidth)) * (maxTop - minTop);

            // Ensure the result doesn't exceed maxTop (60%)
            const finalTop = Math.min(interpolatedTop, maxTop);

            // Convert to viewport height percentage
            setTopOffset(`${finalTop}vh`);
        };

        // Update opacity and pointer events on scroll
        const handleScroll = () => {
            const scrollPosition = window.scrollY; // Get current scroll position
            const fadeOutPoint = 100; // Scroll distance where opacity starts fading
            const maxFadePoint = 300; // Scroll distance where opacity is 0

            const newOpacity = Math.max(0, 1 - (scrollPosition - fadeOutPoint) / (maxFadePoint - fadeOutPoint));
            setScrollOpacity(newOpacity);

            // Update pointer events based on opacity
            if (newOpacity === 0) {
                setPointerEvents('none');
            } else {
                setPointerEvents('auto');
            }
        };

        // Initial calculation for topOffset and scrollOpacity
        updateTopOffset();
        handleScroll();

        // Add event listeners
        window.addEventListener('resize', updateTopOffset);
        window.addEventListener('scroll', handleScroll);

        // Cleanup listeners on unmount
        return () => {
            window.removeEventListener('resize', updateTopOffset);
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <section
            className="main-screen-container"
            style={{
                paddingTop: topOffset, // Fluid top offset in vh
                transition: 'padding-top 0.1s ease', // Smooth transition
            }}
        >
            <img
                src={SmartSolutionsGroupLogo}
                alt="Smart Solutions Group Logo"
                className="main-screen-logo"
            />
            <h1 className="pain-screen-title text-center bold px-2">The Smart Solutions Group</h1>
            {
                /*             <a href="#companies">
                <span
                    id="scrollIndicator"
                    style={{
                        opacity: scrollOpacity, // Dynamically set opacity
                        pointerEvents: pointerEvents, // Disable interaction when fully transparent
                        transition: 'opacity 0.3s ease, pointer-events 0.3s ease', // Smooth transitions
                    }}
                />
            </a> */

            }
            <h2 id="main-screen-slogan" className='bold text-center p-4'>One Group, Infinite Solutions. Working Together to Build Your Future</h2>
        </section>
    );
}

export default MainScreen;
